import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { timeFromNow } from '../../util/date';
import { getContent, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import { LIST_SHIFT_VIEW, TICKET_LIST_NEW_MANAGER_ASSIGN_UPDATE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import DescDropdown from '../Common/DescDropdown';
import Alert from '../Alert/Alert';

class TicketPhoneSideOutside extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reset: false,
            shift: {
                page: 1,
                limit: 10,
                data: [],
                value: '',
                index: null
            },
            customerService: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
            },
            customerServiceId: 0,
            customerServiceName: '',
            showConfirmAlertAssignTicket: false,
            showConfirmAlertReassignAssigned: false,
            showConfirmAlertReassignInprogress: false,
            showSuccessAlertAssignTicket: false,
            showAlertError: false,
            showAlertErrorReassign: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleAssignCustomerService = () => {
        if (this.state.customerServiceId === 0) {
            return this.setState({ showAlertError: true });
        }

        this.setState({
            showConfirmAlertAssignTicket: true,
            customerServiceId: this.state.customerServiceId
        });
    }

    handleAssignTicket = () => {
        const data = {
            updated_at: this.props.data.updated_at,
            assignee_id: this.state.customerServiceId
        }

        API_TICKET_LIST.putDataAssignByLead(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlertAssignTicket: true,
                    showConfirmAlertAssignTicket: false
                });
                setTimeout(() => {
                    this.setState({
                        showSuccessAlertAssignTicket: false,
                        reset: true,
                        customerServiceId: 0
                    });
                    this.props.refresh();
                    this.props.closeSide();
                }, 1500);
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertAssignTicket: false
                });
            })
    }

    handleReassignCustomerService = () => {
        if (this.state.customerServiceId === 0) {
            return this.setState({ showAlertError: true });
        }

        if (this.state.customerServiceName === this.props.data.cs) {
            return this.setState({ showAlertErrorReassign: true });
        }

        if (this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && this.props.data.is_escalated) {
            return this.setState({
                showConfirmAlertReassignInprogress: true,
                customerServiceId: this.state.customerServiceId
            });
        }

        this.setState({
            showConfirmAlertReassignAssigned: true,
            customerServiceId: this.state.customerServiceId
        });
    }

    handleReassignTicketAssigned = () => {
        const data = {
            updated_at: this.props.data.updated_at,
            assignee_id: this.state.customerServiceId
        }

        API_TICKET_LIST.putDataReassignByLead(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlertAssignTicket: true,
                    showConfirmAlertReassignAssigned: false
                });
                this.handleCloseChatroom();
                setTimeout(() => {
                    this.setState({
                        showSuccessAlertAssignTicket: false,
                        reset: true,
                        customerServiceId: 0
                    });
                    this.props.refresh();
                    this.props.closeSide();
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertReassignAssigned: false
                });
            })
    }

    handleReassignTicketInprogress = () => {
        const data = {
            updated_at: this.props.data.updated_at,
            assignee_id: this.state.customerServiceId
        }

        API_TICKET_LIST.putDataReassignInProgress(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlertAssignTicket: true,
                    showConfirmAlertReassignInprogress: false
                });
                this.handleCloseChatroom();
                setTimeout(() => {
                    this.setState({
                        showSuccessAlertAssignTicket: false,
                        reset: true,
                        customerServiceId: 0
                    });
                    this.props.refresh();
                    this.props.closeSide();
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertReassignInprogress: false
                });
            })
    }

    handleCloseChatroom = async () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true' && this.props.data.cs_client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.data.cs_client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            const data = {
                room_id: roomId,
                user_id: this.props.data.cs_client_id,
                ticket_id: this.props.data.id
            };
            await API_TICKET_LIST.postDataUploadChat(data, this.props.token)
            API_TICKET_LIST.postCloseChatroom(data, this.props.token)
        }
    }

    handleChangeCustomerService = data => {
        this.setState({
            customerServiceId: data.value,
            customerServiceName: data.label
        });
        this.props.handleChangeCustomerService(data);
    }

    handleReset = () => {
        this.setState({ reset: false });
    }

    handleLeftShift = () => {
        const left = document.querySelector("#listshift");
        left.scrollBy(-200, 0);
    }

    hanldeRightShift = () => {
        const right = document.querySelector("#listshift");
        right.scrollBy(200, 0);
    }

    handleSelectShift = index => {
        this.setState({
            shift: {
                ...this.state.shift,
                value: this.state.shift[index],
                index
            },
            customerServiceId: 0,
            customerServiceName: '',
            reset: true
        });
        this.getListUserCustomerService(this.state.shift.data[index].id);
    }

    getListShift = () => {
        API_TICKET_LIST.getListShift(this.state.shift.page, this.state.shift.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        shift: {
                            ...this.state.shift,
                            data: getContent(res),
                            value: getContent(res)[0]
                        }
                    });
                }
            })
    }

    getListUserCustomerService = id => {
        API_TICKET_LIST.getListUserCustomerService(this.state.customerService.page, this.state.customerService.limit, id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        customerService: {
                            ...this.state.customerService,
                            data: getContent(res),
                        }
                    });
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        if (CheckPermissionApi(LIST_SHIFT_VIEW, this.props.userDetail.permissions) && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            this.getListShift();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="h-full">
                {
                    window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW) && this.props.userDetail.level !== ROLE_CATEGORY_CONSTANT.CSO &&
                    <div className="h-1/2 pb-5 select-none">
                        <div className="bg-white rounded-md px-6 py-3 h-full">
                            <div className="flex justify-between items-center text-lg py-5">
                                <FontAwesomeIcon icon={faChevronLeft} className="cursor-pointer pr-2" id="btnleftassign" onClick={() => this.handleLeftShift()} />
                                <div className="overflow-auto hide-scroll" id="listshift">
                                    {
                                        this.state.shift.data.length > 0 ? this.state.shift.data.map((data, index) =>
                                            <p className={index === this.state.shift.index ? "px-2 mx-2 mt-2 text-darkblue font-medium pb-0.5 cursor-pointer border-b border-darkblue" : "px-2 mx-2 mt-2 text-gray-500 font-medium pb-0.5 cursor-pointer border-b border-transparent"} key={index} onClick={() => this.handleSelectShift(index)}>{data.shift_description}</p>
                                        ) : <p className="px-2 mx-2 mt-2 text-gray-500 font-medium pb-0.5 border-b border-transparent text-center w-full">Belum ada shift</p>
                                    }
                                </div>
                                <FontAwesomeIcon icon={faChevronRight} className="cursor-pointer pl-2" id="btnrightassign" onClick={() => this.hanldeRightShift()} />
                            </div>
                            <p className="text-sm font-medium mb-1">Customer Service</p>
                            <div className="w-full">
                                <DescDropdown
                                    placeholder="Pilih Customer Service"
                                    handleChange={data => this.handleChangeCustomerService(data)}
                                    data={this.state.customerService.data.map(data => ({ value: data.user_nexcare_id, label: data.name, description: data.speciality === null ? [] : data.speciality, isOnline: data.is_online }))}
                                    reset={this.state.reset}
                                    handleReset={this.handleReset}
                                />
                                <CheckPermissionComponent permissionConstant={[TICKET_LIST_NEW_MANAGER_ASSIGN_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                    <div className="w-full text-right mt-2">
                                        {
                                            this.props.data.status === STATUS_TICKET_CONSTANT.UNASSIGNED
                                                ? <button type="button" id="btnassign" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none py-1 px-5" onClick={() => this.handleAssignCustomerService()}>Assign</button>
                                                : <button type="button" id="btnreassign" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none py-1 px-5" onClick={() => this.handleReassignCustomerService()}>Reassign</button>
                                        }
                                    </div>
                                </CheckPermissionComponent>
                            </div>
                        </div>
                    </div>
                }
                <div className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW) && this.props.userDetail.level !== ROLE_CATEGORY_CONSTANT.CSO ? "h-1/2 bg-white rounded-md overflow-y-auto px-6 py-8" : "h-full bg-white rounded-md overflow-y-auto px-6 py-8"} >
                    <div className="flex items-start border-b border-gray-500 pb-5">
                        <div className="bg-darkblue text-white flex items-center justify-center rounded-full font-bold box-lg">{this.props.data.customer?.charAt(0)}</div>
                        <div className="ml-2">
                            <div>{this.props.data.customer} melaporkan via Telepon</div>
                            <div className="text-super-small mb-1">{timeFromNow(this.props.data.open_at, this.props.serverTime)} ({moment.utc(this.props.data.created_at).format('ddd, DD MMMM YYYY')} di jam {moment.utc(this.props.data.created_at).format('HH:mm')})</div>
                            <div className="text-xs mb-1">{this.props.data.principal} | {this.props.data.ticket_no} | {this.props.data.percentage}%</div>
                            <div className="text-xs mb-1">PIC: {this.props.data.pic_name}</div>
                        </div>
                    </div>
                    <div className="text-gray-600 pt-5">
                        <p className="font-medium">{this.props.data.issue_title}</p>
                        <p className="text-sm">{this.props.data.issue_desc} oleh {this.props.data.operator_name}</p>
                    </div>
                </div>
                <Alert show={this.state.showConfirmAlertAssignTicket} icon="warning" button={true} title="Apakah Anda yakin menugaskan CS ini?" close={() => this.setState({ showConfirmAlertAssignTicket: false })} submit={() => this.handleAssignTicket()} />
                <Alert show={this.state.showConfirmAlertReassignAssigned} icon="warning" button={true} title="Apakah Anda yakin menugaskan CS ini?" close={() => this.setState({ showConfirmAlertReassignAssigned: false })} submit={() => this.handleReassignTicketAssigned()} />
                <Alert show={this.state.showConfirmAlertReassignInprogress} icon="warning" button={true} title="Apakah Anda yakin menugaskan CS ini?" close={() => this.setState({ showConfirmAlertReassignInprogress: false })} submit={() => this.handleReassignTicketInprogress()} />
                <Alert show={this.state.showSuccessAlertAssignTicket} icon="success" title="Berhasil menugaskan CS!" />
                <Alert show={this.state.showAlertError} icon="warning" title="Silahkan pilih CS terlebih dahulu!" close={() => this.setState({ showAlertError: false })} ok />
                <Alert show={this.state.showAlertErrorReassign} icon="warning" title="Anda tidak dapat memilih CS yang sama, Silahkan pilih CS yang lain!" close={() => this.setState({ showAlertErrorReassign: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => { this.setState({ showErrorAlertResponse: false }); this.props.refresh(); }} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(TicketPhoneSideOutside);